import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './ServiceBanner.scss';
import serviceBanner from '../../assets/servicePage/1.png';
import ServicesData from '../Services/ServiceData';

const ServiceBanner = () => {
    const location = useLocation();
    const path = location.pathname.substring(1); // Remove the leading slash
    
    // Find the service based on the path
    let currentService = {
        title: "Dental Services",
        description: "At Loft Dentaire Laval, we provide a wide range of dental services to meet all your oral health needs."
    };
    
    // Map paths to service titles
    const pathToTitle = {
        'general-dentistry': 'General Dentistry',
        'teeth-whitening': 'Teeth Whitening',
        'root-canals': 'Root Canals',
        'wisdom-teeth': 'Wisdom teeth',
        'veneers': 'Veneers',
        'dental-implants': 'Dental Implants',
        'crowns-and-bridges': 'Crowns and Bridges',
        'invisalign': 'Invisalign',
        'orthodontics': 'Orthodontics',
        'services': 'Dental Services'
    };
    
    // Find the service in ServicesData
    if (pathToTitle[path]) {
        const serviceTitle = pathToTitle[path];
        const foundService = ServicesData.find(s => s.title === serviceTitle);
        if (foundService) {
            currentService = {
                title: foundService.title,
                description: foundService.description
            };
        }
    }

    return (
        <section className='service-banner-section section-common section-bg'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 col-md-6">
                                <div className="service-banner-text" data-aos="fade-up" data-aos-duration="2000">
                                    <h2>{currentService.title}</h2>
                                    <p>{currentService.description}</p>
                                    <div className="theme-btn">
                                        <Link to="/contact">Book an appointment</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-6">
                                <div className="service-banner-img" data-aos="fade-up" data-aos-duration="2000">
                                    <img src={serviceBanner} alt="service" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;
